/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import ReactModal from 'react-modal';

import useModalComponent from 'src/shared/app/base/modal/hook/useModalComponent';
import { containerId } from 'src/shared/app/base/constant/domConstants';

const ModalCenter = (): ?React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [component, data] = useModalComponent();

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    ReactModal.setAppElement(document.getElementById(containerId));
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  if (component) {
    return React.createElement(component, data);
  }
};

export default compose(React.memo)(ModalCenter);
